import CustomViewDialogStore from "csi/middleware/customView/CustomViewDialogStore";
import TableCustomViewController from "csi/table/TableCustomViewController";
import declare from "dojo/_base/declare";
import CustomViewImageFormatStore from "./CustomViewImageFormatStore";
import CustomViewNamesStore from "./CustomViewNamesStore";
import NamesTab from "./NamesTab";

const ExportCustomViewController = declare(TableCustomViewController, {

	/** @property {CustomViewDialogStore} store - CustomViewDialogStore */
	store: null,

	/**
	 * @override
	 * create namesStore, which will contain names export CV settings
	 */
	onCreateStoreOptions(store: CustomViewDialogStore): void {
		this.inherited(arguments);
		const { loc, optionValues  } = store;
		const { namesSettings } = optionValues;
		const { attributesStore } = store;
		store.namesStore = new CustomViewNamesStore(attributesStore, namesSettings);
		store.imageFormatStore = new CustomViewImageFormatStore(optionValues, loc);
		store.namesStore.component = NamesTab;
	},

});

export = ExportCustomViewController;